import moment from "moment";
import { useEffect, useState } from "react";
import { useQuery } from 'react-query';
import { useQueryClient } from 'react-query';
import AdminLogin from "../pages/backoffice/AdminLogin";
import styled from 'styled-components';

import AdminMainTemplate from "../pages/backoffice/AdminMainTemplate";
import { ADMIN_MENU } from "../components/common/constants";



const MainWrap = styled.div`
    // width: calc(100% - 24px);
    // padding: 12px;
    font-family: Pretendard;
    font-weight: 400;
    @media all and ${({ theme }) => theme.windowSize.base} {
        font-size: ${({ theme }) => theme.fontSize.base};
    }
    @media all and ${({ theme }) => theme.windowSize.sm} {
        font-size: ${({ theme }) => theme.fontSize.sm};
    }
    @media all and ${({ theme }) => theme.windowSize.lg} {
        font-size: ${({ theme }) => theme.fontSize.lg};
    }
    transition: all ease-in 0.3s;
`;

const AdminContainers = ({target, menuKey}) => {

    const queryClient = useQueryClient();
    const { data : {uid} } = useQuery('ADMIN_USER_INFO', {initialData:{}});

    const [naviInfo, setNaviInfo] = useState();

    useEffect(()=>{
        if(!uid){
            const targetInfo = localStorage.getItem('ADMIN_USER_INFO');

            if(targetInfo){
                const conv = JSON.parse(targetInfo);
                if(conv.ex_date > moment().format("yyyyMMDDHHmmss")){
                    queryClient.setQueryData('ADMIN_USER_INFO',conv);
                }
            }
        }
        
    },[target])

    useEffect(()=>{
        const temp = ADMIN_MENU[menuKey];
        if(temp){
            const fMenu = temp.TYPE === 'SUB' && ADMIN_MENU[temp.P_MENU];
            if(fMenu){
                const pathInfo = fMenu.TYPE === 'SUB' ? [{url:ADMIN_MENU[fMenu.P_MENU].URL,text:ADMIN_MENU[fMenu.P_MENU].TEXT} , {url:fMenu.URL,text:fMenu.TEXT}, {url:temp.URL,text:temp.TEXT}] : [{url:fMenu.URL,text:fMenu.TEXT}, {url:temp.URL,text:temp.TEXT}];
                setNaviInfo(pathInfo);
            }else{
                const pathInfo = [{url:temp.URL,text:temp.TEXT}];
                setNaviInfo(pathInfo);
            }
        }
    },[menuKey])

return (
        <MainWrap>
            {uid ? <AdminMainTemplate target={target} naviInfo={naviInfo} /> : <AdminLogin />}
        </MainWrap>
    )
}

export default AdminContainers;